import { useEffect, useState } from "react";
import auth from "@/apis/auth";

export function useActiveSite() {
  const [site, setSite] = useState<string>("");

  useEffect(() => {
    let mounted = true;
    auth.userProfile()
      .then(res => {
        const n =
          res?.data?.active_site_name ||
          res?.data?.active_site ||
          "";
        if (mounted) setSite(n);
      })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  return site;
}
